import { render, staticRenderFns } from "./Privacy.vue?vue&type=template&id=3900dde9&scoped=true&"
var script = {}
import style0 from "./Privacy.vue?vue&type=style&index=0&id=3900dde9&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3900dde9",
  null
  
)

export default component.exports